import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TalentHappyPathAuthService } from "./talent-happy-path-auth.service";
import { TalentHappyPathAuthApiService } from "./talent-happy-path-auth-api.service";
import { TalentHappyPathDataService } from './talent-happy-path-data-service';

@Injectable({
  providedIn: 'root'
})
export class TalentHappyPathAuthResolver implements Resolve<any> {

  constructor(
    private authService: TalentHappyPathAuthService,
    private apiService: TalentHappyPathAuthApiService,
    private talentHappyPathDataService: TalentHappyPathDataService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    const routeData = route.parent.data;
    this.talentHappyPathDataService.isGeneralApplication = routeData['isGeneralApplication'] || false;
    if (this.authService.isAuthenticated()) {
      let urlParts = state.url.split('/');

      // url format should be /quick-apply/postingId/submit or quick-apply/account
      if (urlParts.length >= 3) {
        let jobPostingId = this.talentHappyPathDataService.isGeneralApplication ? "": urlParts[2];
        return this.apiService.searchTalentByToken(this.authService.authentication.id_token, jobPostingId).pipe(
          map(talent => {
            this.talentHappyPathDataService.talent = talent;
            return talent;
          }),
          catchError( error => {
            console.log("Error retrieving talent info");
            return of(null);
          })
        );
      } else {
        return of({error: 'Invalid url structure.'});
      }
    }
    return of(null);
  }
}
